import { useState, useEffect } from 'react'

/**
 * a hook that tells if a component has mounted
 */
const useHasMounted = (): boolean => {
  const [hasMounted, setHasMounted] = useState(false)

  useEffect(() => {
    setHasMounted(true)
  }, [])

  return hasMounted
}
export default useHasMounted
